import { render, staticRenderFns } from "./CodeInvitesClinic.vue?vue&type=template&id=2871a876&scoped=true"
import script from "./CodeInvitesClinic.vue?vue&type=script&lang=js"
export * from "./CodeInvitesClinic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2871a876",
  null
  
)

export default component.exports